import React, { useState, useRef } from 'react';
import Button from 'components/Button';
import parser from 'fast-xml-parser';
import he from 'he';

function ImportarXmlViagem({ onXmlProcessed, setFieldValue }) {
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const addXmltoJson = (Xmlcte) => {
    const options = {
      attributeNamePrefix: '@_',
      attrNodeName: 'attr',
      textNodeName: '#text',
      ignoreAttributes: true,
      ignoreNameSpace: false,
      allowBooleanAttributes: false,
      parseNodeValue: true,
      parseAttributeValue: false,
      trimValues: true,
      cdataTagName: '__cdata',
      cdataPositionChar: '\\c',
      parseTrueNumberOnly: false,
      numParseOptions: {
        hex: true,
        leadingZeros: true,
      },
      arrayMode: false,
      attrValueProcessor: (val, attrName) =>
        he.decode(val, { isAttributeValue: true }),
      tagValueProcessor: (val, tagName) => he.decode(val),
      stopNodes: ['parse-me-as-string'],
      alwaysCreateTextNode: false,
    };

    if (parser.validate(Xmlcte) === true) {
      let jsonObj = parser.parse(Xmlcte, options);
    }

    const tObj = parser.getTraversalObj(Xmlcte, options);
    return parser.convertToJson(tObj, options);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);
    const reader = new FileReader();

    reader.onload = () => {
      const binaryStr = reader.result;
      const jsonCte = addXmltoJson(binaryStr);

      if (jsonCte) {
        const { NFe } = jsonCte?.NFe ? jsonCte : jsonCte.nfeProc;

        if (binaryStr.indexOf('Id=') < 0 || !NFe) {
          alert('O arquivo selecionado é inválido!');
          setLoading(false);
          return;
        }

        // Extrair chave de acesso da NFe
        let chaveNfe = '';
        try {
          // A chave está no atributo Id da tag infNFe, formato: "NFe35200112345678901234567890123456789012345678"
          const idMatch = binaryStr.match(/Id="NFe(\d{44})"/);
          if (idMatch && idMatch[1]) {
            chaveNfe = idMatch[1];
            setFieldValue('chave_nfe', chaveNfe);
          } else if (NFe.infNFe && NFe.infNFe['@_Id']) {
            // Tentar pegar do JSON parseado
            const idValue = NFe.infNFe['@_Id'];
            if (idValue && idValue.startsWith('NFe')) {
              chaveNfe = idValue.replace('NFe', '');
              setFieldValue('chave_nfe', chaveNfe);
            }
          }
        } catch (chaveError) {
          console.warn('Erro ao extrair chave NFe:', chaveError);
        }

        // Preencher dados da viagem com base no XML
        try {
          const defaultCpf = '0'.repeat(11);
          const defaultCnpj = '0'.repeat(14);

          // Preencher dados do destinatário (que será usado na viagem)
          if (NFe.infNFe.dest) {
            const dest = NFe.infNFe.dest;
            const enderDest = dest.enderDest;

            // Preencher destinatário
            if (dest.CPF) {
              const cpf = (defaultCpf + dest.CPF).slice(-11);
              setFieldValue('destinatario_cpf_cnpj', cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'));
            } else if (dest.CNPJ) {
              const cnpj = (defaultCnpj + dest.CNPJ).slice(-14);
              setFieldValue('destinatario_cpf_cnpj', cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'));
            }

            if (dest.xNome) {
              setFieldValue('destinatario_nome_razao_social', dest.xNome.trim());
            }

            if (enderDest) {
              if (enderDest.CEP) {
                const cep = enderDest.CEP.toString().replace(/(\d{5})(\d{3})/, '$1-$2');
                setFieldValue('destinatario_cep', cep);
              }
              if (enderDest.xLgr) {
                setFieldValue('destinatario_logradouro', enderDest.xLgr.trim());
              }
              if (enderDest.nro) {
                setFieldValue('destinatario_numero', enderDest.nro.toString());
              }
              if (enderDest.xCpl) {
                setFieldValue('destinatario_complemento', enderDest.xCpl.trim());
              }
              if (enderDest.xBairro) {
                setFieldValue('destinatario_bairro', enderDest.xBairro.trim());
              }
              if (enderDest.UF) {
                setFieldValue('destinatario_uf', enderDest.UF.trim());
              }
              if (enderDest.xMun) {
                setFieldValue('destinatario_municipio_descricao', enderDest.xMun.trim());
              }
            }

            if (dest.email) {
              setFieldValue('destinatario_email', dest.email);
            }
          }

          // Preencher dados do emitente (remetente)
          if (NFe.infNFe.emit) {
            const emit = NFe.infNFe.emit;
            const enderEmit = emit.enderEmit;

            if (emit.CNPJ) {
              const cnpj = (defaultCnpj + emit.CNPJ).slice(-14);
              setFieldValue('remetente_cpf_cnpj', cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'));
            }

            if (emit.xNome) {
              setFieldValue('remetente_nome_razao_social', emit.xNome.trim());
            }

            if (emit.IE) {
              setFieldValue('remetente_inscricao_estadual', emit.IE);
            }

            if (enderEmit) {
              if (enderEmit.CEP) {
                const cep = enderEmit.CEP.toString().replace(/(\d{5})(\d{3})/, '$1-$2');
                setFieldValue('remetente_cep', cep);
              }
              if (enderEmit.xLgr) {
                setFieldValue('remetente_logradouro', enderEmit.xLgr.trim());
              }
              if (enderEmit.nro) {
                setFieldValue('remetente_numero', enderEmit.nro.toString());
              }
              if (enderEmit.xCpl) {
                setFieldValue('remetente_complemento', enderEmit.xCpl.trim());
              }
              if (enderEmit.xBairro) {
                setFieldValue('remetente_bairro', enderEmit.xBairro.trim());
              }
              if (enderEmit.UF) {
                setFieldValue('remetente_uf', enderEmit.UF.trim());
              }
              if (enderEmit.xMun) {
                setFieldValue('remetente_municipio_descricao', enderEmit.xMun.trim());
              }
            }
          }

          // Preencher valores de transporte
          if (NFe.infNFe.total) {
            if (NFe.infNFe.total.ICMSTot?.vNF) {
              setFieldValue('valor_carga', NFe.infNFe.total.ICMSTot.vNF.toString());
            }
          }

          // Preencher dados de transporte
          if (NFe.infNFe.transp) {
            const transp = NFe.infNFe.transp;
            if (transp.modFrete !== undefined) {
              // modFrete: 0=Por conta do Remetente, 1=Por conta do Destinatário
              // Isso pode ser usado para definir o tomador
              if (transp.modFrete === 0) {
                setFieldValue('tomador_tipo', '0'); // Remetente
              } else {
                setFieldValue('tomador_tipo', '3'); // Destinatário
              }
            }
          }

          if (onXmlProcessed) {
            onXmlProcessed();
          }

          alert('XML importado com sucesso! Os dados foram preenchidos automaticamente.');
        } catch (error) {
          console.error('Erro ao processar XML:', error);
          alert('Erro ao processar XML. Verifique se o arquivo está correto.');
        }
      } else {
        alert('O arquivo selecionado é inválido!');
      }

      setLoading(false);
      // Limpar o input para permitir selecionar o mesmo arquivo novamente
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    };

    reader.onerror = () => {
      alert('Erro ao ler o arquivo!');
      setLoading(false);
    };

    reader.readAsBinaryString(file);
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div style={{ marginBottom: '20px' }}>
      <input
        ref={fileInputRef}
        type="file"
        accept=".xml"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      <Button
        label={loading ? 'Processando XML...' : 'Importar XML'}
        onClick={handleButtonClick}
        disabled={loading}
        type="secondary"
        width="auto"
        height="32px"
        margin="0 10px 0 0"
      />
    </div>
  );
}

export default ImportarXmlViagem;

